import { render, staticRenderFns } from "./SeoDetay.vue?vue&type=template&id=ae3234dc&scoped=true&"
import script from "./SeoDetay.vue?vue&type=script&lang=js&"
export * from "./SeoDetay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae3234dc",
  null
  
)

export default component.exports